export { AppPromoModule } from './AppPromoModule';
